/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeliPublicationDraftResponse } from './MeliPublicationDraftResponse';
import type { PropertyPortalPublication } from './PropertyPortalPublication';
/**
 * Response returned after persisting a draft and enqueueing a MercadoLibre publish action.
 */
export type MeliEnqueuedPublicationDraftResponse = {
    /**
     * Durable property publication record targeted by the queued action.
     */
    publication: PropertyPortalPublication;
    /**
     * Draft snapshot used to populate the durable record.
     */
    draft: MeliPublicationDraftResponse;
    /**
     * Action that was queued.
     */
    action: MeliEnqueuedPublicationDraftResponse.action;
    /**
     * Whether the action was accepted for async execution.
     */
    queued: boolean;
};
export namespace MeliEnqueuedPublicationDraftResponse {
    /**
     * Action that was queued.
     */
    export enum action {
        PUBLISH = 'publish',
    }
}

